var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":_vm.label || ''}},[_c('b-select',{attrs:{"value":_vm.value,"options":_vm.options},on:{"input":_vm.formChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }